"use strict";

import React from 'react';
import moment from 'ofs/moment';
import {FluxMixin, StoreWatchMixin} from 'fluxxor';

import {gettext, interpolate} from 'ofs/i18n';
import ContactForm from 'ofs/components/contact/unit/component';
import {generateMinMaxMessage} from 'ofs/components/MinMaxMessage';

import BookingQuote from './BookingQuote';
import DateInputs from './DateInputs';

import {trackOptimizelyOpen as trackOptimizelyOpen} from 'ofs/apps/core/utils/tracking/optimizely';

var messages = {
  ENQUIRE: gettext("You'll need to enquire about this date range."),
  LOADING: gettext("Loading ..."),
  BOOK_NOW: gettext("Book now"),
  ASK_A_QUESTION: gettext("Ask a question"),
  APPROXIMATE: gettext("Approximate conversion"),
  FINAL_AMOUNT: gettext("Final amount and payment will be in %(alternativeCurrencyISO)s. The conversion rate will be determined by your bank.")
};


var BookingForm = React.createClass({
  /* eslint-disable new-cap */
  mixins: [
    FluxMixin(React),
    StoreWatchMixin("BookingQuoteStore", "AvailabilityStore", "UnitStore")
  ],
  /* eslint-enable new-cap */

  getStateFromFlux() {
    var flux = this.getFlux();

    return {
      availability: flux.store('AvailabilityStore').state,
      quote: flux.store('BookingQuoteStore').state,
      unit: flux.store('UnitStore').state
    };
  },

  openContactForm(source, enquireAvailability) {
    var quoteStore = this.getFlux().store('BookingQuoteStore');
    trackOptimizelyOpen(source);
    this.getFlux().actions.layers.addModal(
      <ContactForm
        unit={this.state.unit.get('name')}
        unitShortCode={this.state.unit.get('shortCode')}
        city={this.state.unit.get('city')}
        startDate={quoteStore.getFormattedStartDate()}
        endDate={quoteStore.getFormattedEndDate()}
        source={source}
        enquireAvailability={enquireAvailability}
      />
    );
  },

  handleAskAQuestionClick(event) {
    event.preventDefault();
    this.openContactForm('ask a question', false);
  },

  handleEnquireClick(event) {
    event.preventDefault();
    this.openContactForm('enquire home availability', true);
  },

  handleSelect(startValue, endValue) {
    var range = moment().range(startValue, endValue);
    var stayLength = moment.duration(range.end.diff(range.start)).asDays();

    var {availability} = this.state;
    var dateStates = availability.get('stateRanges');
    var needsEnquire = dateStates.filter(state => (
        state.get('range').contains(range.start) ||
        state.get('range').contains(range.end)
      ) && state.get('state') === 'enquire'
    ).count() > 0;

    needsEnquire = !needsEnquire && stayLength < this.state.availability.get('minimumStay');

    this.getFlux().actions.calendar.completeRangeSelection(range, this.state.availability.get('stateRanges').toJS());

    if (needsEnquire) {
      this.openContactForm('enquire home availability', true);
    }
  },

  componentDidMount() {
    this.getFlux().store('BookingQuoteStore').updateQuote();
  },

  render() {
    var {quote, availability} = this.state;

    var range = quote.get('range');
    var hasDates = !!range;

    var minimumStay = availability.get('minimumStay');
    var maximumStay = availability.get('maximumStay');
    var quoteData = quote.get('quoteData');
    var loading = quote.get('loading');
    var needsEnquire = !loading && quote.get('range') && !quote.get('bookable');
    var alternativeCurrencyISO = quote.get('alternativeCurrencyISO');

    var stateDefinitions = availability.get('stateDefinitions').toJS();
    var dateStates = availability.get('stateRanges').toJS();

    var startDate = null;
    var endDate = null;
    if (range) {
      startDate = range.start.toDate();
      endDate = range.end.toDate();
    }

    var helpMessage = generateMinMaxMessage(minimumStay, maximumStay);

    return (
      <form className="ofs-Form -form--large" method="post" action={this.state.quote.get('bookUrl')}>
        <div className="ofs-Form__Fields">
          <DateInputs initialStartValue={startDate} initialEndValue={endDate}
            stateDefinitions={stateDefinitions}
            dateStates={dateStates}
            defaultState="available"
            labels={false}
            startField="start_date"
            endField="end_date"
            onSelect={this.handleSelect}
            helpMessage={helpMessage} />
        </div>

        {needsEnquire ? <p><a href="#" onClick={this.handleEnquireClick}>{messages.ENQUIRE}</a></p> : null}
        {this.state.quote.get('range') && quoteData ? <BookingQuote data={quoteData} /> : null}
        {loading ? <p>{messages.LOADING}</p> : null}

        <button style={{marginBottom: 10}} className="ofs-Button ofs-Button--full-width" disabled={!this.state.quote.get('bookable')}>{messages.BOOK_NOW}</button>
        <a style={{marginBottom: 10}} className="ofs-Button ofs-Button--full-width ofs-Button--secondary" onClick={this.handleAskAQuestionClick}>{messages.ASK_A_QUESTION }</a>

        {quoteData && alternativeCurrencyISO ? <div className="currency_disclaimer">
            <strong>{messages.APPROXIMATE}</strong> {interpolate(messages.FINAL_AMOUNT, {alternativeCurrencyISO}, true)}
        </div> : null}
      </form>
    );
  }
});

export default BookingForm;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/views/BookingForm.jsx
 **/